import * as actionTypes from './actionTypes'

import criteriaAxios from '../../axios/criteria'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchCriteria = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchCriteriaStart())

    criteriaAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchCriteriaSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaFailed(error))
      })
  }
}

export const fetchCriteriaStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_START
  }
}

export const fetchCriteriaSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_CRITERIA_SUCCESS,
    pagination,
    records
  }
}

export const fetchCriteriaFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_FAILED,
    errorMessage
  }
}

export const fetchCriteriaById = recordId => {
  return dispatch => {
    dispatch(fetchCriteriaStart())
    criteriaAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaFailed(error))
      })
  }
}

export const fetchCriteriaByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_CRITERIA_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedCriteriaRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_CRITERIA_RECORD
  }
}

export const createCriteria = (recordData, page) => {
  return dispatch => {
    dispatch(createCriteriaStart())

    criteriaAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Criteria Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createCriteriaSuccess())
          dispatch(fetchCriteria(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Criteria field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createCriteriaFailed())
      })
  }
}

export const createCriteriaStart = () => {
  return {
    type: actionTypes.CREATE_CRITERIA_START
  }
}

export const createCriteriaSuccess = () => {
  return {
    type: actionTypes.CREATE_CRITERIA_SUCCESS
  }
}

export const createCriteriaFailed = () => {
  return {
    type: actionTypes.CREATE_CRITERIA_FAILED
  }
}

export const updateCriteria = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateCriteriaStart())

    criteriaAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Criteria Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateCriteriaSuccess())
        dispatch(fetchCriteria(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Criteria field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateCriteriaFailed())
      })
  }
}

export const updateCriteriaStart = () => {
  return {
    type: actionTypes.UPDATE_CRITERIA_START
  }
}

export const updateCriteriaSuccess = () => {
  return {
    type: actionTypes.UPDATE_CRITERIA_SUCCESS
  }
}

export const updateCriteriaFailed = () => {
  return {
    type: actionTypes.UPDATE_CRITERIA_FAILED
  }
}

export const deleteCriteria = (recordId, page) => {
  return dispatch => {
    dispatch(deleteCriteriaStart())
    criteriaAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Criteria Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteCriteriaSuccess())
        dispatch(fetchCriteria(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteCriteriaFailed())
      })
  }
}

export const deleteCriteriaStart = () => {
  return {
    type: actionTypes.DELETE_CRITERIA_START
  }
}

export const deleteCriteriaSuccess = () => {
  return {
    type: actionTypes.DELETE_CRITERIA_SUCCESS
  }
}

export const deleteCriteriaFailed = () => {
  return {
    type: actionTypes.DELETE_CRITERIA_FAILED
  }
}

export const fetchLevelTable = recordId => {
  let params = { ...recordId }
  return dispatch => {
    dispatch(fetchLevelTableStart())
    criteriaAxios
      .get('/datatable', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelTableSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelTableFailed(error))
      })
  }
}

export const fetchLevelTableStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_TABLE_START
  }
}

export const fetchLevelTableSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_TABLE_SUCCESS,
    data
  }
}

export const fetchLevelTableFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_TABLE_FAILED,
    errorMessage
  }
}

export const fetchCriteriaFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchCriteriaFilterCompanyStart())
    criteriaAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaFilterCompanyFailed(error))
      })
  }
}

export const fetchCriteriaFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_COMPANY_START
  }
}

export const fetchCriteriaFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchCriteriaFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchCriteriaFilterCriteria = filter => {
  return dispatch => {
    dispatch(fetchCriteriaFilterCriteriaStart())
    criteriaAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaFilterCriteriaSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaFilterCriteriaFailed(error))
      })
  }
}

export const fetchCriteriaFilterCriteriaStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_CRITERIA_START
  }
}

export const fetchCriteriaFilterCriteriaSuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_CRITERIA_SUCCESS,
    data
  }
}

export const fetchCriteriaFilterCriteriaFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_CRITERIA_FAILED,
    errorMessage
  }
}

export const fetchCriteriaFilterLevel = filter => {
  return dispatch => {
    dispatch(fetchCriteriaFilterLevelStart())
    criteriaAxios
      .get('/orglevel/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaFilterLevelSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaFilterLevelFailed(error))
      })
  }
}

export const fetchCriteriaFilterLevelStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_LEVEL_START
  }
}

export const fetchCriteriaFilterLevelSuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_LEVEL_SUCCESS,
    data
  }
}

export const fetchCriteriaFilterLevelFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_FILTER_LEVEL_FAILED,
    errorMessage
  }
}
